const tooltipPopperProps = {
    modifiers: [
        {
            name: "offset",
            options: {
                offset: [0, -6]
            }
        }
    ]
};
export const MuiTooltip = {
    defaultProps: {
        enterDelay: 250,
        enterNextDelay: 250,
        PopperProps: tooltipPopperProps,
        arrow: true,
        placement: "top"
    },
    styleOverrides: {
        tooltip: ({ theme }) => ({
            backgroundColor: theme.palette.secondary.main,
            fontColor: "white",
            fontSize: "12px",
            fontWeight: 400,
            borderRadius: "4px",
            display: "flex",
            flexDirection: "column",
            gap: "8px"
        }),
        arrow: ({ theme }) => ({
            color: theme.palette.secondary.main
        })
    }
};
//# sourceMappingURL=Tooltip.js.map